module.exports = __webpack_public_path__ + "img/heart-plus.85f2d348.svg";